import React, { useEffect, useRef, useState } from "react";
import "../styles/mysip.css";
import growthTree from "../images/icons/growth-tree.svg";
import featureimage from "../images/orders/logo.svg";
import SipAndLumpsumCart from "../components/SipAndLumpsumCart";
import { useNavigate } from "react-router-dom";
import BuySipLumpsumModel from "./BuySipLumpsumModel"; // Modal import
import { useDispatch, useSelector } from "react-redux";
import { cartProceed, getCards } from "../actions/cardAction";
import { useFormik } from "formik";
import * as Yup from "yup";
import BuyLumpsumModel from "./BuyLumpsumModel";
import {
  getLocalStorageUserData,
  getLocalStorageUserId,
} from "../utils/userData";
import { toast } from "react-toastify";
import PopupModel from "../components/PopupModel";
import { formatCartProceedPayload } from "../utils/cartUtils";
import successlogo from "../images/popup/success-popup.svg";
import cancel from "../images/popup/alert-image.svg";
const MySipAndLumpsum = () => {
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const carddata = useSelector((state) => state.myCard);
  const [disabled, setDisable] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Manage popup visibility
  const closeModal = () => {
    setIsPopupVisible(false);
  };

  const userId = getLocalStorageUserId();
  const userData = getLocalStorageUserData();

  // useEffect(() => {
  //   const payload = {
  //     id: userId,
  //   };
  //   dispatch(getCards(payload));
  // }, [dispatch, userId]);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        id: userId,
      };

      try {
        // Prevent multiple API calls by ensuring the state is only set once
        // if (!isMounted.current) return; // Prevent fetch if the component is unmounted
        if (userId) {
          await dispatch(getCards(payload));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // if (isMounted.current) {
    fetchData();
    // } else {
    //   isMounted.current = true;
    // }

    // Cleanup function to mark the component as unmounted
    // return () => {
    //   isMounted.current = false;
    // };
  }, [dispatch, userId]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModel, setOpenModel] = useState(1);
  const [runPopUp, setRunPopUp] = useState(false);
  const [exploreSipData, setExploreSipData] = useState();
  const [totalInvest, setTotalInvest] = useState(0);
  const [sipDataMap, setSipDataMap] = useState({});
  const handleModalOpen = () => setIsModalOpen(true); // Open Modal
  const handleModalClose = () => setIsModalOpen(false); // Close Modal
  const initialData = carddata?.addToCardData?.data;

  const formik = useFormik({
    initialValues: {
      ...initialData,
      products_in_cart: initialData?.products_in_cart?.map((product) => ({
        ...product,
        amount: product?.cart_product?.minimum_amount, // Add default values for new fields
        invest_type: product?.invest_type
          ? product?.invest_type
          : product?.frequencies?.length > 0
            ? "S"
            : "N",
        investment_mode: product?.invest_type
          ? product?.invest_type
          : product?.frequencies?.length > 0
            ? "S"
            : "N",
        until_cancel: 0,
      })),
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      products_in_cart: Yup.array().of(
        Yup.object({
          investment_mode: Yup.string().required("Investment type is required"),
          // folio: Yup.string().when("invest_type", (invest_type, schema) => {
          //   return invest_type[0] === "lumpsum" || invest_type[0] === "sip"
          //     ? schema.required("Folio is required")
          //     : schema;
          // }),
          amount: Yup.string().when(
            "investment_mode",
            (investment_mode, schema) => {
              return investment_mode[0] === "N"
                ? schema
                  .required("Amount is required")
                  .test("min-amount", function (value) {
                    const { investment_mode, cart_product } =
                      this.parent || {};
                    const minAmount =
                      investment_mode === "S"
                        ? cart_product?.master_scheme?.new_purchase_min_amount
                        : investment_mode === "N"
                          ? cart_product?.master_scheme?.new_purchase_min_amount
                          : 0;

                    // If minimum amount is not met, return a custom error message
                    if (!value || Number(value) < minAmount) {
                      return this.createError({
                        path: this.path,
                        message: `Amount must be at least ${minAmount}`,
                      });
                    }

                    // If validation passes, return true
                    return true;
                  })
                : schema
                  .required("Amount is required")
                  .test(
                    "sip-amount-range",
                    "Invalid amount",
                    function (value) {
                      const { path, parent, options } = this;
                      const index = parseInt(
                        path.match(/\[(\d+)\]/)?.[1],
                        10
                      );

                      const sipDetails = sipDataMap?.[index]?.[0]; // assuming array structure: { 0: [{...}] }

                      const minAmount =
                        Number(sipDetails?.sip_minimum_installment_amount) ||
                        100;
                      const maxAmount =
                        Number(sipDetails?.sip_maximum_installment_amount) ||
                        999999;

                      if (!value) {
                        return this.createError({
                          path,
                          message: "Amount is required",
                        });
                      }

                      const numericValue = Number(value);

                      if (numericValue < minAmount) {
                        return this.createError({
                          path,
                          message: `Amount must be at least ₹${minAmount}`,
                        });
                      }

                      if (numericValue > maxAmount) {
                        return this.createError({
                          path,
                          message: `Amount must not exceed ₹${maxAmount}`,
                        });
                      }

                      return true;
                    }
                  );
            }
          ),
          date_installment: Yup.string()
            .notOneOf(["Select"], "Day is required")
            .when("investment_mode", (investment_mode, schema) => {
              return investment_mode[0] === "S"
                ? schema.required("Day is required")
                : schema;
            }),

          frequency_type: Yup.string()
            .notOneOf(["Select"], "frequency is required")
            .when("investment_mode", (investment_mode, schema) => {
              return investment_mode[0] === "S"
                ? schema.required("frequency is required")
                : schema;
            }),

          installment_no: Yup.string().when(
            ["investment_mode", "until_cancel", "frequency_type"],
            (values, schema) => {
              const [investment_mode, until_cancel, frequency_type] = values;

              if (investment_mode === "S" && until_cancel != 1) {
                return schema
                  .required("No of Installment is required")
                  .notOneOf(["Select"], "No of Installment is required")
                  .matches(/^[0-9]+$/, "Only numbers are allowed");
              }
              return schema.notRequired().nullable();
            }
          ),

          end_date: Yup.string().when(
            ["investment_mode", "until_cancel", "frequency_type"],
            (values, schema) => {
              const [investment_mode, until_cancel, frequency_type] = values;
              if (
                investment_mode === "S" &&
                until_cancel == "0" &&
                frequency_type == "DAILY"
              ) {
                return schema
                  .required("End Date is required")
                  .notOneOf(["Select"], "End Date is required");
              }
              return schema;
            }
          ),
          // noofinstallment: Yup.string()
          //   .notOneOf(["Select"], "No of Installment is required")
          //   .when("invest_type", (invest_type, schema) => {
          //     return invest_type[0] === "sip"
          //       ? schema.required("No of Installment is required")
          //       : schema;
          //   }),
          step_up_required: Yup.string(),
          step_up_amount: Yup.string().when(
            ["investment_mode", "step_up_required"],
            (values, schema) => {
              const [investment_mode, step_up_required] = values;
              if (investment_mode === "S") {
                if (step_up_required == "true") {
                  return schema.required("Step amount is required");
                }
                return schema.notRequired();
              }
              return schema;
            }
          ),
          step_up_frequency: Yup.string()
            .notOneOf(["Select"], "Step frequency is required")
            .when(["investment_mode", "step_up_required"], (values, schema) => {
              const [investment_mode, step_up_required] = values;
              if (investment_mode === "S") {
                if (step_up_required == "true") {
                  return schema.required("Step frequency is required");
                }
                return schema.notRequired();
              }
              return schema;
            }),
          // reinvest: Yup.string()
          //   .notOneOf(["Select"], "Reinvest is required")
          //   .required("Reinvest is required"),
          // final_amt: Yup.string().when(
          //   ["invest_type", "stepup"],
          //   (values, schema) => {
          //     const [invest_type, stepup] = values;
          //     if (invest_type === "sip") {
          //       if (stepup == "true") {
          //         return schema.required("Final amount is required");
          //       }
          //       return schema.notRequired();
          //     }
          //     return schema;
          //   }
          // ),
          folioList: Yup.array(),
        })
      ),
    }),
    onSubmit: (values) => {
      setDisable(true);
      const payload = [];
      values?.products_in_cart?.map((res, index) => {
        payload.push({
          master_scheme_id: res?.cart_product?.master_scheme?.id,
          scheme_code: res?.cart_product?.master_scheme?.scheme_code,
          amc_code: res?.cart_product?.master_scheme?.amc_code,
          isin: res?.cart_product?.master_scheme?.isin,
          is_additional_purchase:
            res?.cart_product?.trxn_mode == "FRESH"
              ? false
              : res?.cart_product?.trxn_mode == "ADDITIONAL"
                ? true
                : "",
          minimum_amount:
            res?.investment_mode == "S"
              ? sipDataMap?.[index]?.[0]?.sip_minimum_installment_amount
              : res?.investment_mode == "N"
                ? res?.minimum_amount == undefined
                  ? "0"
                  : res?.minimum_amount
                : "0",
          amount: res?.amount,
          investment_mode:
            res?.investment_mode == "S"
              ? "S"
              : res?.investment_mode == "N"
                ? "N"
                : "",
          folioNumber: res?.cart_product?.folio,
          sip_remarks: res?.cart_product?.sip_remarks,
          reinvest: res?.cart_product?.reinvest,
          date_installment: res?.date_installment
            ? res?.date_installment
            : res?.cart_product?.sip_start_date,
          end_date: res?.end_date,
          frequency_type: res?.frequency_type,
          installment_no: res?.installment_no ? res?.installment_no : '',
          first_order_today: res?.cart_product?.first_order_today,
          step_up_required: res?.step_up_required,
          step_up_start_date: res?.step_up_start_date,
          step_up_end_date: res?.step_up_end_date,
          step_up_frequency: res?.step_up_frequency,
          step_up_amount: res?.step_up_amount,
          until_cancel: res?.investment_mode == "S" ? res?.until_cancel : 0,
        });
      });
      const finalResponse = formatCartProceedPayload(values.products_in_cart, userData?.client_code);
      dispatch(cartProceed(finalResponse))
        .then((response) => {
          if (response?.response) {
            if (response?.response?.data?.status == true) {
              setDisable(false);
              if (response?.response?.data?.mandate?.length == 0) {
                setIsPopupVisible(true);
              }

              // toast.error("Please check Bank added or not!");
            } else {
              toast.error(response?.response?.data?.notFound?.[0]?.message);
              setDisable(false);
            }
          } else {
            // setIsPopupVisible(true);
            // toast.error("Please check Bank added or not!");
            setDisable(false);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.notFound?.[0]?.message);
          // setIsPopupVisible(true);
          // toast.error("Please check Bank added or not!");
          setDisable(false);
        });
      setRunPopUp(true);
    },
  });

  useEffect(() => {
    if (carddata?.proceedCarts?.status == true && runPopUp == true) {
      formik?.values?.products_in_cart.some(
        (product) => product.investment_mode === "S"
      )
        ? setOpenModel(1)
        : setOpenModel(2);
      handleModalOpen();
    }
  }, [carddata?.proceedCarts, runPopUp]);

  const actionPopup = (val) => {
    if (val != 1) {
      navigate("/my-profile");
    }
  };
  useEffect(() => {
    setTotalInvest(0);
    let previousValue = 0;

    formik?.values?.products_in_cart?.forEach((res) => {
      const newValue = parseInt(res?.amount) || 0; // Handle cases where amount might be null or undefined
      // Update the total investment
      setTotalInvest((prevTotal) => {
        const updatedTotal = prevTotal + newValue;
        previousValue = newValue; // Update the previous value for the next iteration
        return updatedTotal;
      });
    });
  }, [formik?.values]);

  return (
    <div className="container-fluid page_background">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box page_content_overflow">
          <h5 className="mb-4 main-heading-title">My Cart</h5>

          <div className="order_box pt-2">
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <SipAndLumpsumCart
                  values={formik?.values?.products_in_cart}
                  handleChange={formik?.handleChange}
                  setFieldValue={formik?.setFieldValue}
                  formik={formik}
                  resetForm={formik?.resetForm}
                  sipDataMap={sipDataMap}
                  setSipDataMap={setSipDataMap}
                />
              </div>

              {formik?.values?.products_in_cart?.length > 0 && (
                <div className="cart-bottom d-flex">
                  <p className="mb-0">
                    Total Investment Amount{" "}
                    <span className="">₹{totalInvest}</span>
                  </p>
                  <button
                    type="submit"
                    className="form_button next_btn"
                    disabled={disabled}
                  //   onClick={handleModalOpen} // Open modal on click
                  >
                    Proceed
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Pass state and close function to modal component */}
      {openModel == 1 ? (
        <BuySipLumpsumModel
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          amt={totalInvest}
          products_in_cart={formik.values.products_in_cart}
          client_code={carddata?.addToCardData?.data?.customer?.client_code}
        // handleOtpVerify={handleOtpVerify} // Pass OTP verify function
        // isOtpVerified={isOtpVerified} // Pass OTP state
        />
      ) : (
        <BuyLumpsumModel
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          amt={totalInvest}
          products_in_cart={formik.values.products_in_cart}
          client_code={carddata?.addToCardData?.data?.customer?.client_code}
        />
      )}

      {isPopupVisible && (
        <PopupModel
          id="alertModel"
          title="Information"
          content={"You have not registered for eNACH, please register."}
          image={cancel}
          actionPopup={actionPopup}
          closeModal={closeModal}
          btnColor={"btn-success"}
          later={"btn-primary"}
        />
      )}
    </div>
  );
};

export default MySipAndLumpsum;
